import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { SHOW_NEWSLETTER } from '../config';
import { AMAZON_ABC_BOOK_URL, BUY_LABEL } from '../data/library';

/**
 * Grown-up signup + book CTA for free games/tunes pages (newsletter list is the main asset).
 */
export default function ParentNewsletterCta({ variant = 'band' }) {
  if (!SHOW_NEWSLETTER) {
    return (
      <aside className={`parent-cta parent-cta--${variant}`} aria-labelledby="parent-cta-book-heading">
        <h2 id="parent-cta-book-heading" className="parent-cta__title">
          Ready for story time?
        </h2>
        <p className="parent-cta__lead">
          Pick up the ABC coloring book adventure on Amazon — the perfect next step after playtime.
        </p>
        <a
          href={AMAZON_ABC_BOOK_URL}
          className="btn-buy-amazon parent-cta__amazon"
          target="_blank"
          rel="noopener noreferrer"
        >
          {BUY_LABEL} — ABC book
          <FiExternalLink size={18} aria-hidden />
        </a>
      </aside>
    );
  }

  return (
    <aside className={`parent-cta parent-cta--${variant}`} aria-labelledby="parent-cta-heading">
      <h2 id="parent-cta-heading" className="parent-cta__title">
        Grown-ups: join the weekly list
      </h2>
      <p className="parent-cta__lead">
        Free games and song previews are just the start. Get one cheerful email each week with new books on Amazon,
        merch news, and what&apos;s next in Libby&apos;s world — then grab a story for bedtime.
      </p>
      <div className="parent-cta__actions">
        <a href="/#newsletter" className="parent-cta__primary">
          Join the newsletter
        </a>
        <a
          href={AMAZON_ABC_BOOK_URL}
          className="parent-cta__secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {BUY_LABEL} — ABC coloring book
          <FiExternalLink size={16} aria-hidden />
        </a>
      </div>
    </aside>
  );
}
